import AuthService from '../../services/AuthService';

const Auth = new AuthService();

export function getEntretienHeader(id_entretien){
    return {
        type:"GET_ENTRETIEN_HEADER",
        payload: Auth.fetch('/societe/entretien/'+id_entretien)
    }
}

export function setEntretienHeader(entretienHeader){
    return {
        type:"SET_ENTRETIEN_HEADER",
        payload: entretienHeader
    }
}

export function getFormations(id_entretien, id_salarie){
    return {
        type:"GET_FORMATIONS",
        payload: Auth.fetch(`/salarie/${id_salarie}/formations/${id_entretien}`)
    }
}

export function getImpactPerspectives(id_entretien){
    return {
        type:"GET_IMPACT_PERSPECTIVES",
        payload: Auth.fetch(`/salarie/${id_entretien}/impact_perspectives`)
    }
}

export function getActivitesPrincipales(id_entretien){
    return {
        type:"GET_ACTIVITES_PRINCIPALES",
        payload: Auth.fetch(`/salarie/entretien/${id_entretien}/activites_poste_actuel`)
    }
}
export function getCompetences(id_entretien){
    return {
        type:"GET_COMPETENCES",
        payload: Auth.fetch(`/salarie/entretien/${id_entretien}/competences`)
    }
}
export function getPointsAmelioration(id_entretien){
    return {
        type:"GET_POINTS_AMELIORATION",
        payload: Auth.fetch(`/salarie/entretien/${id_entretien}/points_amelioration`)
    }
}
export function getProjetsPro(id_entretien){
    return {
        type:"GET_PROJETS_PRO",
        payload: Auth.fetch(`/salarie/entretien/${id_entretien}/projet_pro`)
    }
}

export function setActivitesPrincipales(activites){
    return {
        type:"SET_ACTIVITES_PRINCIPALES",
        payload: activites
    }
}

export function setPointsAmelioration(points_amelioration){
    Auth.fetch('/salarie/points_amelioration',{method:'put', data:points_amelioration});
    return {
        type:"SET_POINTS_AMELIORATION",
        payload: points_amelioration
    }
}

export function setFormations(formations){
    return {
        type:"SET_FORMATIONS",
        payload: formations
    }
}


// WEBPACK FOOTER //
// ./src/actions/entreprise/actions_entreprise_entretien.js